/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "webPresenceCloud",
            "endpoint": "https://v99p8ob6va.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:c4e2f173-2da4-494b-8169-4a441bc091ea",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_bZmECAPIb",
    "aws_user_pools_web_client_id": "16966u95d3mr8sv85sqgktak8u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "webpresence-bucket-123455eb51-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
